import { render } from "./OfflineNotification.vue?vue&type=template&id=5abb9d6e&ts=true"
import script from "./OfflineNotification.vue?vue&type=script&lang=ts"
export * from "./OfflineNotification.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/OfflineNotification.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5abb9d6e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5abb9d6e', __exports__)) {
    api.reload('5abb9d6e', __exports__)
  }
  
  module.hot.accept("./OfflineNotification.vue?vue&type=template&id=5abb9d6e&ts=true", () => {
    api.rerender('5abb9d6e', render)
  })

}


export default __exports__